import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f7c61d3e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7c61d3e')) {
      api.createRecord('f7c61d3e', component.options)
    } else {
      api.reload('f7c61d3e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f7c61d3e&", function () {
      api.rerender('f7c61d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GZ57B9oWzZAL/JS/comp/ImgFallback.vue"
export default component.exports